import { readConfig, e } from '@bayerntek/config/src'

export type Config = ReturnType<typeof get_config>
export const get_config = () =>
  readConfig(
    {
      app_version: e(String, '0-dev'),
      app_name: e(String),
      is_auth_enabled: e(Boolean, true),
      is_multitab: e(Boolean, false),
      company: {
        name: e(String, 'bayerntek'),
        domain: e(String, 'localhost'),
      },
      identity: {
        api: e(String),
      },
      platform: {
        api: e(String),
      },
      graphql: {
        api: e(String),
      },
    } as const,
    'VITE',
  )
